module.exports = __webpack_public_path__ + "res/20-img_card_bg.56d1e42c5795f54e28d54f8568f05caa.png";